module.exports = __webpack_public_path__ + "static/assets/e0d93cd3493391d7b7badb501e86a97f.svg";